import type { IAuditLog, IColumnLevelTrackingRecord } from '@condo/domain';
import type {
    GetAuditLogDiffPathParams,
    GetAuditLogDiffQueryResponse,
    GetDatabaseTablesAndColumnsQueryParams,
    GetDatabaseTablesAndColumnsQueryResponse,
    GetHistoryAuditLogsForAggregateQueryParams,
    GetNthChangesForTableQueryResponse,
} from '@condo/sdk/listing-persister';
import { getClient } from './api-client';

export const fetchDatabaseTablesAndColumns = async (params: GetDatabaseTablesAndColumnsQueryParams): Promise<GetDatabaseTablesAndColumnsQueryResponse> =>
    getClient('listingPersister').getDatabaseTablesAndColumns(params);

export const fetchAuditLogDiff = async (params: GetAuditLogDiffPathParams): Promise<GetAuditLogDiffQueryResponse> =>
    getClient('listingPersister').getAuditLogDiff(params);

export const fetchAuditAsHistory = async (params: GetHistoryAuditLogsForAggregateQueryParams): Promise<IAuditLog[]> =>
    getClient('listingPersister')
        .getHistoryAuditLogsForAggregate(params)
        .then(e => e.auditLogs);

export const fetchLatestChangesForColumns = async (database: string, table: string, pk: string, columns: string): Promise<IColumnLevelTrackingRecord[]> =>
    getClient('listingPersister')
        .getLatestChangesForColumns({ database, table, pk, columns })
        .then(e => e.latest);

export const fetchNthChanges = async (params: {
    page: number;
    size: number;
    database: string;
    table: string;
    pk?: string;
    columns?: string[];
    userUid?: string;
}): Promise<GetNthChangesForTableQueryResponse> => {
    if (params.pk && params.columns?.length) {
        return getClient('listingPersister').getNthChangesForColumns(
            { ...params, columns: params.columns.join(','), pk: params.pk! },
            { page: params.page, size: params.size, userUid: params.userUid ?? undefined },
        );
    }

    if (params.pk) {
        return getClient('listingPersister').getNthChangesForRows(
            { ...params, pk: params.pk! },
            { page: params.page, size: params.size, userUid: params.userUid ?? undefined },
        );
    }

    return getClient('listingPersister').getNthChangesForTable(params, { page: params.page, size: params.size });
};
